import { render, staticRenderFns } from "./UplimitPromotion.vue?vue&type=template&id=1b00857b&scoped=true"
import script from "./UplimitPromotion.vue?vue&type=script&lang=js"
export * from "./UplimitPromotion.vue?vue&type=script&lang=js"
import style0 from "./UplimitPromotion.vue?vue&type=style&index=0&id=1b00857b&prod&scoped=true&lang=css"
import style1 from "./UplimitPromotion.vue?vue&type=style&index=1&id=1b00857b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b00857b",
  null
  
)

export default component.exports